import { NestApiType, nestCall } from '@/composables/nestApi';

export type ProvisioningStage =
  | 'queued'
  | 'db_create'
  | 'db_connect'
  | 'migrate'
  | 'seed'
  | 'finalize'
  | 'done';

export interface ProvisioningSnapshot {
  stage: ProvisioningStage;
  progress: number;
}

const FALLBACK: ProvisioningSnapshot = { stage: 'queued', progress: 0 };

const toSnapshot = (raw: any): ProvisioningSnapshot => {
  if (!raw || typeof raw !== 'object') {
    return FALLBACK;
  }
  const stage = (raw.stage as ProvisioningStage) ?? 'queued';
  const progress = typeof raw.progress === 'number' ? raw.progress : 0;
  return { stage, progress };
};

export const startProvisioning = async (
  idShop: number,
): Promise<ProvisioningSnapshot> => {
  try {
    const res = await nestCall(
      'post',
      NestApiType.DEFAULT,
      `/provisioning/${idShop}/start`,
    );
    const snap = toSnapshot(res);
    return snap;
  } catch (err) {
    return FALLBACK;
  }
};

export const fetchProvisioningStatus = async (
  idShop: number,
): Promise<ProvisioningSnapshot> => {
  try {
    const res = await nestCall(
      'get',
      NestApiType.DEFAULT,
      `/provisioning/${idShop}/status`,
    );
    const snap = toSnapshot(res);

    return snap;
  } catch (err) {
    return FALLBACK;
  }
};
